import { render, staticRenderFns } from "./customize-card.vue?vue&type=template&id=6e27ae5e&scoped=true&"
import script from "./customize-card.vue?vue&type=script&lang=js&"
export * from "./customize-card.vue?vue&type=script&lang=js&"
import style0 from "./customize-card.vue?vue&type=style&index=0&id=6e27ae5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e27ae5e",
  null
  
)

export default component.exports